import { Check } from "lucide-react";
import { TIERS } from "@/lib/honor";

export const TierPicker = ({ value, onChange, disabled, testId = "honor-tier" }) => (
  <div className="grid grid-cols-3 gap-2" role="radiogroup" aria-label="Ehren-Stufe">
    {Object.entries(TIERS).map(([k, t]) => (
      <button key={k} type="button" role="radio" aria-checked={value === k} disabled={disabled} onClick={() => onChange(k)} data-testid={`${testId}-${k}`}
        className={`tier-${k} honor-card rounded-2xl p-3 flex flex-col items-center gap-1 text-center transition-transform relative ${value === k ? "ring-[3px] ring-offset-2 ring-[var(--h3)] scale-[1.04]" : "opacity-60 hover:opacity-100 grayscale-[30%]"}`}>
        {value === k && <span className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-[var(--h3)] text-white flex items-center justify-center shadow" data-testid={`${testId}-${k}-active`}><Check className="w-3.5 h-3.5" strokeWidth={3} /></span>}
        <span className="honor-ring w-9 h-9 rounded-full p-[3px]"><span className="w-full h-full rounded-full bg-white flex items-center justify-center"><t.icon className="w-4 h-4 text-[var(--h3)]" /></span></span>
        <span className="text-xs font-extrabold honor-title">{t.label}</span>
        <span className="text-[10px] text-slate-500 leading-tight">{t.text}</span>
      </button>
    ))}
  </div>
);
